import React, {CSSProperties, ReactNode} from "react";
import './OneFeature.scss';

interface ICircle{
    content:string;
}
export const Circle = (props:ICircle)=>{
    return (
        <div className="custom-circle">
            <div className="inner-circle">
                {props.content}
            </div>
        </div>
    )
}


const getCls = function (type:number){
    switch (type){
        // type=1 适用于 第一个section的样式
        case 1: return "square1";
        //type=2适用于 产品特点的样式
        case 2: return "product";
        case 3: return "system";
        default: return '';
    }
}

interface IOneFeature{
    img?: string;
    title: ReactNode;
    content: ReactNode;
    style?: CSSProperties;
    type: number;
    customImg?: ReactNode;
}
export default function OneFeature(props: IOneFeature){

    const {type} = props;
    const cls = getCls(type);

    return (
        <div className={'one-feature '+cls} style={props.style}>
            {props.customImg ??<div className="img-wrapper"><img src={props.img} alt={''}/></div> }
            <div className="font-wrapper">
                <div className="font2">{props.title}</div>
                <div className={"font3 c666"}>{props.content}</div>
            </div>

        </div>
    )
}
